import React, { useRef, useState } from 'react';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../Features/orderDetailsSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';

function ReturnRejectForm({ rejectReturn, updateRejectReason }) {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const [reason, setReason] = useState('');

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const handleRejectButton = () => {
        if(reason.length) {
            rejectReturn();
            dispatch(closeModal());
            updateRejectReason(reason);
        }
        else {
            alert('Write a reason before rejecting!');
        }
    }

    const handleChange = (e) => {
        setReason(e.target.value);
    }

    return (
        <div ref={wrapperRef} className="w-[45%] h-[32rem] bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-3 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex items-center justify-between">
                <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Reason for Rejection</h1>

                <button onClick={handleButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <form className="flex flex-col h-full gap-6">
                <div className="flex flex-col gap-3 h-full">
                    <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="name-input">
                        Please provide a reason for rejection to inform the shopper. This helps maintain trust and transparency.
                    </label>

                    <div className="h-full bg-[#F5F5F5] px-3 py-4 rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                        <textarea 
                            placeholder='Write reason here' 
                            className='w-full h-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                            type="text" 
                            value={reason} 
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <button onClick={handleRejectButton} className='whitespace-nowrap px-4 py-2 rounded font-urbanist-regular font-semibold text-base text-center bg-[#EF4444] text-[#FFFFFF]' type='button'>
                    Reject Return
                </button>
            </form>
        </div>
    );
}

export default ReturnRejectForm;
